// extracted by mini-css-extract-plugin
export var fullWidthButton = "_eo-0";